module.exports = __webpack_public_path__ + "static/wherewework_map3@2x-c323bdaa5b366af8ced900b5c226862a.png";